import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getRioClient, getUUID, sendRioEvent, updateRioState } from './rio';
import { StudentType } from '@chegg/one-auth-sdk';
import { EventTypes, recordEvents } from '../../utils/newRelicEvents';
import { View } from '../../store/types';
export function signupSuccessRioEvent(state, regSourcePage, regSourceProduct, encryptedEmail, encryptedCheggId) {
  var clientId = state.clientId,
    authProvider = state.sso.authProvider,
    _state$signup = state.signup,
    _state$signup$userInf = _state$signup.userInfo,
    userType = _state$signup$userInf.userType,
    _state$signup$userInf2 = _state$signup$userInf.student,
    studentType = _state$signup$userInf2.studentType,
    hsGradYear = _state$signup$userInf2.highschool.hsGradYear,
    _state$signup$userInf3 = _state$signup$userInf2.college,
    yearInCollege = _state$signup$userInf3.yearInCollege,
    campusId = _state$signup$userInf3.campusId,
    name = _state$signup$userInf3.name,
    _state$signup$gdpr = _state$signup.gdpr,
    promos = _state$signup$gdpr.promos,
    termsOfUse = _state$signup$gdpr.termsOfUse;
  var uuid = getUUID();
  var rioData = {
    sign_up: {
      auth_service: clientId === 'CJP' && 'internships' || (authProvider === null || authProvider === void 0 ? void 0 : authProvider.toLowerCase()) || 'chegg'
    }
  };
  if (promos) {
    rioData.sign_up.opt_in_promo_emails = true;
  }
  if (!promos && termsOfUse) {
    rioData.sign_up.opt_in_promo_emails = false;
  }
  if (termsOfUse) {
    rioData.sign_up.gdpr_accept = true;
  }
  rioData.sign_up.reg_source = regSourcePage;
  rioData.sign_up.reg_source_product = regSourceProduct;
  if (userType) {
    // @ts-ignore
    rioData.sign_up.member_role = userType.toLowerCase();
  }
  if (clientId === 'EDU') {
    // special case for honor-shield (EDU) https://chegg.atlassian.net/browse/ROCK-385
    rioData.sign_up.member_role = 'educator';
  }
  if (encryptedEmail) {
    rioData.sign_up.encrypted_email_id = encryptedEmail;
  }
  if (encryptedCheggId) {
    rioData.sign_up.encrypted_chegg_uuid = encryptedCheggId;
  }

  // set student relevant rio data
  if (studentType) {
    if (studentType.toLowerCase() === StudentType.highschool) {
      // @ts-ignore
      rioData.sign_up.school_type = studentType.toLowerCase() === StudentType.highschool ? 'high school' : studentType.toLowerCase();
      if (hsGradYear) {
        rioData.sign_up.high_school_grad_year = hsGradYear;
      }
    } else if (studentType.toLowerCase() === StudentType.college) {
      rioData.sign_up.school_type = StudentType.college;
      if (name) {
        rioData.sign_up.school_name = name;
      }
      if (yearInCollege) {
        rioData.sign_up.year_in_college = yearInCollege;
      }
      if (campusId) {
        rioData.sign_up.school_uuid = campusId;
      }
    }
  }
  try {
    // @ts-ignore
    window.cheggAnalyticsUtils.triggerEvent([{
      eventID: 'event22',
      eventName: 'Sign Up Success',
      eventValue: 'Chegg',
      profile: {
        cheggUUID: uuid,
        encEmailAddress: encryptedEmail,
        encUserId: encryptedCheggId,
        regSourceProduct: regSourceProduct,
        schoolType: rioData.sign_up.school_type,
        userType: rioData.sign_up.member_role
      },
      timeStamp: new Date(),
      type: 'auth'
    }]);
  } catch (error) {
    // do nothing
  }
  getRioClient().updateState({
    cheggUuid: uuid
  });
  return sendRioEvent('clickstream_sign_up_success', rioData);
}
export function signinSuccessRioEvent(authProvider) {
  getRioClient().updateState({
    cheggUuid: getUUID()
  });
  return sendRioEvent('clickstream_sign_in_success', {
    sign_in: {
      auth_service: authProvider
    }
  });
}
export function signupStartRioEvent() {
  return sendRioEvent('clickstream_sign_up_start', {});
}
export function signinStartRioEvent() {
  return sendRioEvent('clickstream_sign_in_start', {});
}

// TODO: change to one type. get rid on initialView
export function sendStartEvents(view) {
  switch (view) {
    case View.SIGNIN:
      signinStartRioEvent();
      recordEvents(_defineProperty({}, EventTypes.loginStart, {}));
      break;
    case View.SIGNUP:
      signupStartRioEvent();
      recordEvents(_defineProperty({}, EventTypes.signupStart, {}));
      break;
  }
}
export function notificationsRioEvent(data) {
  return sendRioEvent('clickstream_notifications', data);
}
export function interactionsRioEvent(data) {
  return sendRioEvent('clickstream_interaction', data);
}
export function successRioEvent(data) {
  return sendRioEvent('clickstream_success', data);
}
export function clickstreamViewEvent(view_name) {
  updateRioState({
    view: {
      view_name: view_name
    }
  });
  return sendRioEvent('clickstream_view', {});
}
export function componentViewEvent(data) {
  return sendRioEvent('clickstream_component_view', data);
}